import { Typography } from "@material-ui/core";

const WelcomeStep = () => {
  return (
    <div>
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginBottom: 25 }}
      >
        Welcome to Efestra, an all-inclusive and completely centralised platform
        built for experimentation teams trying to build better testing teams and
        scaling their programs.
      </Typography>

      <Typography variant="body2" color="textSecondary">
        Before we get started, lets get you setup first!
      </Typography>
    </div>
  );
};

export default WelcomeStep;
